import { z } from 'zod'

export const userManagementSearchSchema = z.object({
  manage: z.string().default('users'),
  page: z.coerce.number().int().min(0).default(0),
  size: z.coerce.number().int().positive().default(25),
  sort: z.string().default('name'),
  sortDirection: z.enum(['ASC', 'DESC']).default('ASC'),
  filter: z.string().default('Any'),
  search: z.string().default('')
})
